import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { System } from '@app/core/resources/system';
import { SystemPaymentQueue, SystemPaymentQueueService } from '@app/core/resources/system-payment-queue';
import { SystemPaymentSent, SystemPaymentSentService } from '@app/core/resources/system-payment-sent';
import { PlatformBrowserService } from '@app/core/services/platform-browser.service';
import { DocumentCollection } from 'ngx-jsonapi';
import { combineLatest, filter, Observable } from 'rxjs';

@Component({
    selector: 'app-payment-queue',
    templateUrl: './payment-queue.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./payment-queue.component.scss']
})
export class PaymentQueueComponent implements OnChanges {
    @Input() public system: System = new System();
    @Input() public paymentId: string = '';
    public isLoaded: boolean = false;
    public systemPaymentQueue: any = [];
    public systemPaymentSent: any = [];
    public showEmptyPaymentQueue: boolean = false;

    public constructor(
        private systemPaymentQueueService: SystemPaymentQueueService,
        private systemPaymentSentService: SystemPaymentSentService,
        private browserService: PlatformBrowserService,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    public ngOnChanges(): void {
        if (!this.browserService.isBrowser || this.system.id === '') {
            return;
        }
        let systemPaymentQueueObservable: Observable<DocumentCollection<SystemPaymentQueue>> = this.systemPaymentQueueService
            .all({ remotefilter: { 'system.id': this.system.id } })
            .pipe(
                filter((system_payment_queues: DocumentCollection<SystemPaymentQueue>): boolean => system_payment_queues.source !== 'new')
            );
        let systemPaymentSentObservable: Observable<DocumentCollection<SystemPaymentSent>> = this.systemPaymentSentService
            .all({ remotefilter: { 'system.id': this.system.id } })
            .pipe(
                filter((systems_payments_sent: DocumentCollection<SystemPaymentSent>): boolean => systems_payments_sent.source !== 'new')
            );
        combineLatest(systemPaymentQueueObservable, systemPaymentSentObservable).subscribe((value) => {
            this.systemPaymentQueue = value[0].data.reverse();
            this.systemPaymentSent = value[1].data;
            if ((this.systemPaymentQueue.length === 0 && this.systemPaymentSent.length === 0) || !this.system.attributes.can_receive) {
                this.showEmptyPaymentQueue = true;
                this.changeDetectorRef.markForCheck();
            }
            this.isLoaded = true;
            this.changeDetectorRef.markForCheck();
            if (document.getElementsByClassName('payment-container')[0]) {
                let appPaymentMethod: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName(
                    'app-payment-method-container'
                ) as HTMLCollectionOf<HTMLElement>;
                const element: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName(
                    'payment-' + this.paymentId
                ) as HTMLCollectionOf<HTMLElement>;

                setTimeout(() => {
                    if (this.paymentId && element[0]) {
                        element[0].scrollIntoView({ block: 'nearest' });
                        appPaymentMethod[0].scrollLeft = appPaymentMethod[0].scrollLeft + appPaymentMethod[0].offsetWidth / 2;
                    } else {
                        appPaymentMethod[0].scrollLeft = appPaymentMethod[0].scrollWidth;
                    }
                    this.changeDetectorRef.markForCheck();
                });
            }
            this.changeDetectorRef.markForCheck();
        });
    }
}
